import styled from "styled-components";

type ImageProps = {
  $img: string;
};
export const NeededCont = styled.div`
 @media (max-width: 430px) {
    display: none;
  }
`;

export const DivCont = styled.div`
  display: none;
 @media (max-width: 430px) {
    display: flex;
    flex-direction: row;
    gap: 100px;
  }
`;
export const Div = styled.div`
  display: none;
 @media (max-width: 430px) {
    display: block;
  }
`;

export const Ul1 = styled.ul`
  font-family: "Avenir Next";
  font-weight: 500;
  text-decoration: none;
  margin-left: 545px;
 @media (max-width: 430px) {
    width: 393px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    padding: 0;
    margin-bottom: 40px;
  }
`;
export const Ul2 = styled.ul`
  font-family: "Avenir Next";
  font-weight: 500;
  text-decoration: none;
  margin-left: 45px;
 @media (max-width: 430px) {
    width: 393px;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 40px;
  }
`;
export const Li = styled.li`
  font-weight: 500;
  text-decoration: none;
  list-style: none;
  margin-bottom: 10px;
  cursor: pointer;
 @media (max-width: 430px) {
    display: block;
  }
`;
export const A = styled.a`
  font-weight: 500;
  text-decoration: none;
  color: black;
  &:hover {
    color: #1983ff;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: black;
  margin-bottom: 10px;
`;

export const BG = styled.div`
  margin: 0 auto;
  width: 100%;
  height: 400px;
  background-color: #eeeff0;
 @media (max-width: 430px) {
    width: 393px;
    justify-content: center;
    margin: 0 auto;
    padding: 0;
    height: 800px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 1400px;
  height: 350px;
  background-color: #eeeff0;
 @media (max-width: 430px) {
    width: 393px;
    justify-content: center;
    margin: 0 auto;
    padding: 0;
    height: auto;
  }
`;

export const Top = styled.div`
  display: flex;
  height: 80%;
  width: 100%;
  margin-left: 375px;
 @media (max-width: 430px) {
    width: 393px;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
  }
`;
export const Bottom = styled.div`
  display: flex;
  width: 100%;
 @media (max-width: 430px) {
    width: 393px;
    justify-content: center;
    flex-direction: column;
    margin: 0 auto;
    padding: 0;
    padding-left: 10px;
  }
`;

export const QuestionBlue = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  background-color: #bfdcf5;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  margin: 0;
  text-decoration: none;
  height: 35px;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
  }
 @media (max-width: 430px) {
    width: 370px;
    margin: 0;
    padding: 0;
    margin-bottom: 20px;
    padding-left: 10px;
  }
`;

export const QuestionWhite = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  background-color: white;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  margin: 0;
  text-decoration: none;
  height: 35px;
  margin-left: 12px;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
  }
 @media (max-width: 430px) {
    width: 370px;
    margin: 0;
    padding: 0;
    margin-bottom: 20px;
  }
`;

export const Text1 = styled.a`
  margin: 0;
  padding: 0;
  display: block;
  font-family: Avenir Next;
  font-weight: 500;
  height: 50px;
  margin-top: 15px;
  margin-left: 280px;
  text-decoration: none;
  color: black;
  &:hover {
    cursor: pointer;
    color: #1983ff;
  }
 @media (max-width: 430px) {
    width: 393px;
    align-items: center;
    margin: 0;
    margin-left: 75px;
    padding: 0;
  }
`;

export const Text2 = styled.div`
  margin: 0;
  padding: 0;
  display: block;
  font-family: Avenir Next;
  font-weight: 400;
  color: #a7a7a7;
  height: 50px;
  margin-top: 15px;
  margin-left: 105px;
 @media (max-width: 430px) {
    width: 393px;
    align-items: center;
    margin: 0;
    margin-left: 85px;
    padding: 0;
  }
`;
export const Text3 = styled.div`
  margin: 0;
  padding: 0;
  display: block;
  font-family: Avenir Next;
  font-weight: 400;
  color: #a7a7a7;
  height: 50px;
`;
export const Text4 = styled.div`
  margin: 0;
  padding: 0;
  display: block;
  font-family: Avenir Next;
  font-weight: 400;
  color: #a7a7a7;
  height: 50px;
`;

export const Logo = styled.img`
  display: block;
  padding: 0;
  width: 200px;
  height: 44px;
  margin: 0;
  margin-top: 20px;
 @media (max-width: 430px) {
    margin: 0 auto;
    margin-bottom: 20px;
  }
`;
